<div class="dvm-landing-page" [style.--landing-accent]="config.accent || '#c8102e'">
  <header class="landing-header">
    <span class="landing-header-icon" *ngIf="config.header.icon">
      <mat-icon>{{ config.header.icon }}</mat-icon>
    </span>
    <div class="landing-header-text">
      <h1 class="landing-header-title">{{ config.header.title }}</h1>
      <p class="landing-header-subtitle" *ngIf="config.header.subtitle">{{ config.header.subtitle }}</p>
    </div>
  </header>

  <div class="landing-section-label" *ngIf="config.sectionLabel">{{ config.sectionLabel }}</div>

  <div class="landing-module-grid">
    <section
      class="landing-module-card"
      *ngFor="let module of config.modules; let i = index"
      [style.--module-accent]="module.accent || config.accent || '#c8102e'"
      [style.grid-column]="moduleGridColumn(module)"
      [style.minHeight.px]="module.minHeight || null"
      [class.selectable]="!interactive"
      [class.layout-edit]="layoutEdit"
      (click)="onModuleCardClick(i)"
    >
      <span class="landing-card-size-badge" *ngIf="layoutEdit">{{ moduleSizeLabel(module) }}</span>
      <div class="landing-module-head">
        <span class="landing-module-icon"><mat-icon>{{ module.icon || 'dashboard' }}</mat-icon></span>
        <span class="landing-module-badge">{{ module.badge }}</span>
      </div>
      <h2 class="landing-module-title">{{ module.title }}</h2>
      <p class="landing-module-description" *ngIf="module.description">{{ module.description }}</p>
      <div class="landing-module-links">
        <ng-container *ngFor="let link of module.links">
          <!-- Group button (has sub-menu items): toggles expansion, never navigates. -->
          <ng-container *ngIf="hasChildren(link); else leafLink">
            <button
              type="button"
              class="landing-module-link landing-module-group"
              [class.primary]="link.style === 'primary'"
              [class.open]="isExpanded(link)"
              (click)="toggleGroup(link, $event)"
            >
              <span class="landing-module-link-label">{{ link.label }}</span>
              <mat-icon class="landing-module-link-arrow">{{ isExpanded(link) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
            <div class="landing-module-sublinks" *ngIf="isExpanded(link)">
              <button
                type="button"
                class="landing-module-link landing-module-sublink"
                *ngFor="let child of link.children"
                [class.primary]="child.style === 'primary'"
                (click)="openLink(child, i, $event)"
              >
                <span class="landing-module-link-label">{{ child.label }}</span>
                <mat-icon class="landing-module-link-arrow">arrow_forward</mat-icon>
              </button>
            </div>
          </ng-container>
          <ng-template #leafLink>
            <button
              type="button"
              class="landing-module-link"
              [class.primary]="link.style === 'primary'"
              (click)="openLink(link, i, $event)"
            >
              <span class="landing-module-link-label">{{ link.label }}</span>
              <mat-icon class="landing-module-link-arrow">arrow_forward</mat-icon>
            </button>
          </ng-template>
        </ng-container>
      </div>
      <span
        class="landing-card-resize-handle"
        *ngIf="layoutEdit"
        title="Drag right/left to make this card wider or narrower"
        (pointerdown)="startCardResize(i, $event)"
      ></span>
    </section>
  </div>
</div>
